import en_US from 'antd/lib/locale/en_US';
import enMessages from '../locales/en_US.json';

const EnLang = {
  messages: {
    ...enMessages,
  },
  antd: en_US,
  locale: 'en-US',
};
export default EnLang;
